/**
 * Capabilities.
 *
 * Order is the message: the two AI entries lead the grid, which is what
 * carries the AI-native positioning. They are not a new venture — both
 * already exist in the site navigation under "Generative AI and Data".
 *
 * Shape
 * -----
 * id     stable key; also selects the icon in SectionServices
 * title  card heading
 * description  one sentence, concrete
 * tags   sub-capabilities, rendered as chips
 * isAi   tints the card so the grid reads AI-first at a glance
 *
 * Icons are inline SVG in SectionServices rather than image assets, so they
 * inherit `currentColor` and stay on the palette.
 */
export const configServices = [
  {
    id: 'aiAgents',
    title: 'AI & agent development',
    description:
      'Assistants and agents that do real work inside your product — grounded in your data, with evaluation and guardrails built in.',
    tags: ['LLM integration', 'RAG', 'Agentic workflows', 'Evals & guardrails'],
    isAi: true,
  },
  {
    id: 'dataMl',
    title: 'Data & ML engineering',
    description:
      'The pipelines, search and feature work AI depends on — so a model has clean, current data to reason over.',
    tags: ['Data pipelines', 'Vector search', 'Machine learning', 'Analytics'],
    isAi: true,
  },
  {
    id: 'customSoftwareDevelopment',
    title: 'Custom software development',
    description:
      'Tailored systems built around how your business actually operates, not around a template.',
    tags: ['Rapid prototyping', 'MVPs', 'Product strategy', 'R&D'],
  },
  {
    id: 'marketplaces',
    title: 'Marketplaces & commerce',
    description:
      'Our specialism: two-sided marketplaces and storefronts with payments, payouts and trust systems that hold up at volume.',
    tags: ['Listings', 'Stripe Connect', 'Search & matching', 'Payouts'],
  },
  {
    id: 'webDevelopment',
    title: 'Web development',
    description:
      'Responsive, accessible web applications on a modern stack, engineered to stay fast as they grow.',
    tags: ['React', 'Node.js', 'Design systems', 'Performance'],
  },
  {
    id: 'mobileAppDevelopment',
    title: 'Mobile app development',
    description:
      'Native-quality iOS and Android products from a shared codebase, shipped through both stores.',
    tags: ['React Native', 'Offline-first', 'Push & payments', 'Store release'],
  },
  {
    id: 'cloudSolutions',
    title: 'Cloud & DevOps',
    description:
      'Scalable, secure infrastructure with CI/CD, observability and cost control built in from day one.',
    tags: ['AWS', 'CI/CD', 'Monitoring', 'GPU & inference cost'],
  },
  {
    id: 'uiUxDesign',
    title: 'UI/UX design',
    description:
      'Research-led interface design that makes complex products feel obvious — including the new patterns AI features need.',
    tags: ['User research', 'UX & UI', 'Design systems', 'AI interaction'],
  },
];
